<template>
  <div>
    <component
      :is="layout"
      :mode="mode"
      :data="data"
      :methods="defineSharedMethods()"
      :actions="defineActions()"
    />
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { graphqlClient } from "@/utils/http";
  import {
    getTeacherById,
    addTeacher,
    updateTeacher
  } from "@/data/graphql/personal-profile/teacher-profile-graphql.js";
  import data from "./data";
  import { mock } from "./data";
  import actions from "./actions";
  import sharedMethods from "./shared-methods";

  export default {
    props: {
      listProfile: Object,
      id: String,
      mode: {
        type: String,
        default: "add"
      },
      filters: Object
    },
    data: () => ({
      ...data
    }),
    components: {
      "layout-default": () => import("./layout-default.vue"),
    },
    computed: {
      layout() {
        return "layout-default"
      }
    },
    methods: {
      async getData(id) {
        return await graphqlClient(getTeacherById(id));
      },
      async addData(profile) {
        const _this = this;
        _this.transformBooleanData(profile);
        return await graphqlClient(addTeacher(profile));
      },
      async editData(profile) {
        const _this = this;
        _this.transformBooleanData(profile);
        return await graphqlClient(updateTeacher(profile));
      },
      convertFilterToFields() {
        this.data.newProfile = { ...this.data.newProfile, ...this.filters };
      },
      convertPreviousProfileToNew() {
        this.data.newProfile = this.createProfileDataModel(this.data.profile);
      },
      createProfileDataModel(profile) {
        
        const {
          id = null,
          code = null,
          firstNameLocal = null,
          lastNameLocal = null,
          firstNameEng = null,
          lastNameEng = null,
          availableTime = null,
          telephone = null,
          email = null,
          picturePath = null,
          socialMedia = null,
          isSpecialTeacher = null,
          isActive = null,
          curriculum = null,
          faculty = null,
          prefix = null,
          userId = null
        } = profile;

        return {
          id: id,
          code: code || null,
          firstNameLocal: firstNameLocal || null,
          lastNameLocal: lastNameLocal || null,
          firstNameEng: firstNameEng || null,
          lastNameEng: lastNameEng || null,
          availableTime: availableTime || null,
          telephone: telephone || null,
          email: email || null,
          picturePath: picturePath || null,
          socialMedia: socialMedia || null,
          isSpecialTeacher: isSpecialTeacher || null,
          isActive: isActive || null,
          curriculumId: curriculum ? curriculum.id : null,
          facultyId: faculty ? faculty.id : null,
          prefixId: prefix ? prefix.id : null,
          userId: userId,
        }
      },
      validateProfileData(profile) {
        // TODO: Create validation logic
        return true;
      },
      resetNewProfile() {
        this.data.newProfile = {
          id: null,
          code: null,
          firstNameLocal: null,
          lastNameLocal: null,
          firstNameEng: null,
          lastNameEng: null,
          availableTime: null,
          telephone: null,
          email: null,
          picturePath: null,
          socialMedia: null,
          isSpecialTeacher: null,
          isActive: null,
          curriculumId: null,
          facultyId: null,
          prefixId: null,
          userId: null,
        }
      },
      checkRequiredFiled(profile) {
        const _this = this;
        const _profile = profile || _this.data.newProfile;
        const passes = {};
        _this.data.requires
          .map(field => {
            passes[field] = _this.checkValidData(_profile[field])
          });
        _this.$set(_this.data, 'warning', passes);
        return passes;
      },
      checkValidData(data) {
        if (
          data !== null
          && data !== "" // Check for no data
          // && (data !== " " && data.length > 1) // Check for blank data
          // && data.match(/^\s+$/) // Check for white space
          // && data.match(/^\s\s+/g) // Check for double space
          // && typeof data !== "undefined" // Check for undefined data
        ) {
          return true;
        }
        return false;
      },
      isAllRequirementPasses() {
        const _this = this;
        const passes = _this.data.requires
          .map(field => _this.data.warning[field])
          .every(bool => bool === true);
        return passes;
      },
      defineSharedMethods() {
        return sharedMethods.bind(this)();
      },
      transformBooleanData(profile) {
        profile.isActive = profile.isActive ? true:false;
        profile.isSpecialTeacher = profile.isSpecialTeacher ? true:false;
      },
      defineActions() {
        return actions.bind(this)();
      },
      async injectMockData() {
        setTimeout(() => {
          this.data.profile = mock;
          this.convertPreviousProfileToNew();
        }, 4000);
      },
      async initData() {
        if (process.env.NODE_ENV === "DEV_STANDALONE") {
          this.data = {
            ...this.dataTemplate(),
            ...await this.injectMockData()
          };
          this.data.noData.flag = false;
        } else {
          this.resetNewProfile();
          if (this.mode === "edit") {
            this.data.profile = await this.getData(this.id);
            this.convertPreviousProfileToNew(this.data.profile);
          } else if (this.mode === "add") {
            this.convertFilterToFields();
          }
        }
      } 
    },
    async created() {
      await this.initData();
    },
    mounted() {
      const _this = this;
      setTimeout(() => {
        _this.$forceUpdate();
      }, 3000);
    }
  }
</script>
